import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">91视频、97视频、51视频热度排行榜实时更新</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl hover:bg-background-100 transition-all duration-200 cursor-pointer group border-b border-background-200/40 last:border-0"
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-bold font-heading ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-950'
                    : item.rank === 2
                    ? 'bg-secondary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-300 text-primary-950'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </span>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap bg-secondary-100 text-secondary-700">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-sm text-foreground-600">{item.views}播放</span>
                <i
                  className={`text-sm ${
                    item.change === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}